import { mockSeasonEvents } from "./rankingSeason";

export interface MockEvent {
  id: string;
  event_group: {
    id: string;
    name: string;
  };
  joined_flg: boolean;
  title: string;
  datetime: string;
  place: string;
  singles_flag: boolean;
  singles_point_flag: boolean;
  singles_ex_point_flag: boolean;
  doubles_flag: boolean;
  doubles_point_flag: boolean;
  match_format: string;
  participation_fee: string;
  other: string;
  participation_start_datetime: string;
  tournament_created_flg: boolean;
  tournament_started_flg: boolean;
  event_ended_flg: boolean;
  singles_ranking_points: Array<{ rank: number; point: number }>;
  doubles_ranking_points: Array<{ rank: number; point: number }>;
  participants: string[];
}

export const mockEvents: MockEvent[] = mockSeasonEvents.map((event) => ({
  id: event.id,
  event_group: event.event_group,
  joined_flg: event.joined_flg,
  title: event.title,
  datetime: event.datetime,
  place: event.place,
  singles_flag: event.singles_flag,
  singles_point_flag: event.singles_point_flag,
  singles_ex_point_flag: event.singles_ex_point_flag,
  doubles_flag: event.doubles_flag,
  doubles_point_flag: event.doubles_point_flag,
  match_format: event.match_format,
  participation_fee: event.participation_fee,
  other: event.other,
  participation_start_datetime: event.participation_start_datetime,
  tournament_created_flg: event.tournament_created_flg,
  tournament_started_flg: event.tournament_started_flg,
  event_ended_flg: event.event_ended_flg,
  singles_ranking_points: event.singles_ranking_points,
  doubles_ranking_points: event.doubles_ranking_points,
  participants: event.participants,
}));
